import { compact, get, uniq } from 'lodash-es';

export const phone = (expose: any) => get(expose, 'phone');
export const mobile = (expose: any) => get(expose, 'mobile');

export const phoneNumbers = (expose: any) =>
  uniq(compact([phone(expose), mobile(expose)]));
